module.exports = __webpack_public_path__ + "img/13.713474b2.jpg";